(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grindz-cinema"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grindz-cinema')) {
  customElements.define('grindz-cinema', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.film = this.querySelector('[data-film]');
      this.screen = this.querySelector('[data-screen]');
      this.canvas = this.querySelector('[data-canvas]');
      this.captions = [...this.querySelectorAll('[data-caption]')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.progress=0;this.target=0;this.pointer=0;this.pointerY=0;this.aimX=0;this.aimY=0;this.visible=true;this.paused=false;this.time=0;
      const pause=this.querySelector('[data-orbit-pause]');
      pause.addEventListener('click',()=>{this.paused=!this.paused;pause.setAttribute('aria-pressed',String(this.paused));if(this.paused){cancelAnimationFrame(this.frame);this.frame=0;}else{this.measure();this.queue();}},{signal});
      const tilt=this.querySelector('[data-orbit-tilt]');
      if('DeviceOrientationEvent' in window&&isSecureContext&&matchMedia('(pointer:coarse)').matches)tilt.hidden=false;
      tilt.addEventListener('click',async()=>{
        if(this.sensor){this.sensor=false;tilt.setAttribute('aria-pressed','false');this.aimX=0;this.aimY=0;return;}
        try{const permission=typeof DeviceOrientationEvent.requestPermission==='function'?await DeviceOrientationEvent.requestPermission():'granted';if(permission!=='granted')throw Error();
          this.sensor=true;this.tiltBase=null;tilt.setAttribute('aria-pressed','true');
          if(!this.sensorBound){this.sensorBound=true;window.addEventListener('deviceorientation',event=>{
            if(!this.sensor||!this.enabled||this.paused||event.gamma===null||event.beta===null)return;
            if(!this.tiltBase)this.tiltBase=[event.gamma,event.beta];
            this.aimX=Math.max(-.20,Math.min(.20,(event.gamma-this.tiltBase[0])*.007));this.aimY=Math.max(-.12,Math.min(.12,(event.beta-this.tiltBase[1])*.004));this.queue();
          },{passive:true,signal});}
        }catch{this.querySelector('[data-orbit-status]').textContent=tilt.dataset.fallback;tilt.hidden=true;}
      },{signal});
      const apply = () => {
        this.enabled = this.dataset.motion === 'true' && !this.reduced.matches && !navigator.connection?.saveData;
        this.dataset.scrub = String(this.enabled);
        if (!this.enabled) {
          cancelAnimationFrame(this.frame); this.frame = 0;
          this.dataset.webgl='fallback';this.querySelector('[data-orbit-pause]').hidden=true;this.updateCaptions(0);this.captions.forEach(c=>{c.style.opacity='';c.style.transform='';c.removeAttribute('aria-hidden');});
        } else if (this.gl) {this.dataset.webgl = 'ready'; this.measure(); this.queue();}
        else this.deferInit();
      };
      this.reduced.addEventListener('change', apply, {signal});
      window.addEventListener('scroll', () => this.measure(), {passive:true, signal});
      this.resize = new ResizeObserver(() => {this.resizeCanvas(); this.measure(); this.queue();});
      this.resize.observe(this.screen);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (this.visible) {this.measure(); this.queue();}
        else {cancelAnimationFrame(this.frame); this.frame = 0;}
      });
      this.observer.observe(this.film);
      this.screen.addEventListener('pointermove', event => {
        if(!this.enabled||this.paused||this.sensor)return;
        const rect=this.screen.getBoundingClientRect();
        this.aimX=(event.clientX/rect.width-.5)*.34;
        this.aimY=(event.clientY-rect.top-rect.height*.5)/rect.height*.20;
        this.queue();
      }, {passive:true, signal});
      this.screen.addEventListener('pointerleave', () => {this.aimX=0;this.aimY=0;this.queue();}, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {cancelAnimationFrame(this.frame); this.frame = 0;}
        else {this.measure(); this.queue();}
      }, {signal});
      this.canvas.addEventListener('webglcontextlost', event => {
        event.preventDefault(); this.gl = null; this.dataset.webgl = 'fallback';
        cancelAnimationFrame(this.frame); this.frame = 0;
      }, {signal});
      this.canvas.addEventListener('webglcontextrestored', () => {if (this.enabled) this.initGL();}, {signal});
      this.screen.addEventListener('click',event=>{
        if(!event.target.closest('[data-story-link]')||!this.enabled)return;
        event.preventDefault();const top=scrollY+this.film.getBoundingClientRect().top+(this.film.offsetHeight-this.screen.offsetHeight)*.30;window.scrollTo({top,behavior:'smooth'});
      },{signal});
      document.addEventListener('grindz:drop-state',event=>{const summary=this.querySelector('[data-drop-summary]');if(summary)summary.textContent=event.detail.label;},{signal});
      this.rewritePreviewLinks();
      apply();
    }
    rewritePreviewLinks() {
      this.querySelectorAll('[data-vault-link]').forEach(link=>{link.href='#GrindzDrop';});
    }
    deferInit() {
      if (this.pendingInit) return;
      this.pendingInit = true;
      const run = () => {this.pendingInit = false;if (this.isConnected && this.enabled) this.initGL();};
      if ('requestIdleCallback' in window) this.idle = requestIdleCallback(run,{timeout:1200});
      else this.initTimer = setTimeout(run,200);
    }
    initGL() {
      try {
        const gl = this.canvas.getContext('webgl', {alpha:true, antialias:true, depth:true, stencil:false, powerPreference:'low-power', preserveDrawingBuffer:false});
        if (!gl) throw new Error('WebGL unavailable');
        this.gl = gl;
        const vertex = `precision highp float;
          attribute vec3 aPosition;attribute vec3 aNormal;attribute vec2 aUV;attribute vec3 aCenter;attribute float aSeed;
          uniform vec3 uAngles;uniform vec4 uCamera;uniform float uAspect;uniform float uBlast;
          varying vec3 vNormal; varying vec3 vPosition; varying vec3 vLocal;
          varying vec3 vX; varying vec3 vY; varying float vFace; varying vec2 vUV;
          void main(){
            vec3 c=cos(uAngles),s=sin(uAngles);
            mat3 rx=mat3(1.,0.,0.,0.,c.x,s.x,0.,-s.x,c.x);
            mat3 ry=mat3(c.y,0.,-s.y,0.,1.,0.,s.y,0.,c.y);
            mat3 rz=mat3(c.z,s.z,0.,-s.z,c.z,0.,0.,0.,1.);
            mat3 rotation=rz*ry*rx;
            vec3 local=aPosition;
            float turn=uBlast*(aSeed*10.-5.);float ct=cos(turn),st=sin(turn);
            mat3 shard=mat3(ct,st,0.,-st,ct,0.,0.,0.,1.);
            vec3 direction=normalize(aCenter+vec3(sin(aSeed*81.)*.4,cos(aSeed*51.)*.4,.3+sin(aSeed*37.)*.5));
            vec3 broken=shard*(local-aCenter)+aCenter+direction*uBlast*(3.+aSeed*5.);
            vec3 p=rotation*broken*uCamera.x+vec3(uCamera.y,uCamera.z,-uCamera.w);
            vNormal=rotation*shard*aNormal;vPosition=p;vLocal=local;vUV=aUV;
            vX=rotation*vec3(1.,0.,0.);vY=rotation*vec3(0.,1.,0.);vFace=abs(aNormal.z);
            gl_Position=vec4(p.x*2.45/uAspect,p.y*2.45,-1.002*p.z-.2002,-p.z);
          }`;
        const fragment = `precision mediump float;
          uniform float uLight;uniform sampler2D uMap;uniform float uHasTexture;uniform float uFade;
          varying vec3 vNormal;varying vec3 vPosition;varying vec3 vLocal;
          varying vec3 vX;varying vec3 vY;varying float vFace;varying vec2 vUV;
          void main(){
            float wave=sin(vLocal.x*3.+vLocal.y*2.)*.07;
            float wave2=cos(vLocal.x*4.-vLocal.y*3.)*.045;
            vec3 normal=normalize(vNormal+(vX*wave+vY*wave2)*step(.8,vFace));
            if(!gl_FrontFacing)normal=-normal;
            vec3 view=normalize(-vPosition),r=reflect(-view,normal);
            float panel=pow(max(0.,1.-abs(r.y*.78+r.x*.5+uLight*.1-.12)),24.);
            float strip=pow(max(0.,dot(r,normalize(vec3(-.5,.75,.4)))),38.);
            float broad=pow(max(0.,dot(r,normalize(vec3(.4,.5,1.)))),5.);
            float rim=pow(1.-abs(dot(normal,view)),2.);
            float metal=.09+broad*.6+panel*.6+strip*.8+rim*.27;
            metal=pow(clamp(metal,0.,1.),.83);
            float grain=dot(texture2D(uMap,vUV).rgb,vec3(.3333));
            metal=mix(metal,grain*.76+metal*.24,step(.8,vFace)*uHasTexture);
            gl_FragColor=vec4(vec3(metal)*uFade,uFade);
          }`;
        const compile = (type,source) => {const shader=gl.createShader(type);gl.shaderSource(shader,source);gl.compileShader(shader);return shader;};
        const vs=compile(gl.VERTEX_SHADER,vertex),fs=compile(gl.FRAGMENT_SHADER,fragment);
        const program=gl.createProgram();gl.attachShader(program,vs);gl.attachShader(program,fs);gl.linkProgram(program);
        if (!gl.getProgramParameter(program,gl.LINK_STATUS)) throw new Error('Shader compilation failed');
        gl.deleteShader(vs);gl.deleteShader(fs);gl.useProgram(program);
        this.program=program;
        const model=JSON.parse(this.querySelector('[data-emblem-model]').textContent);
        const decode=value=>Uint8Array.from(atob(value),c=>c.charCodeAt(0));
        const packed=decode(model.data),view=new DataView(packed.buffer),indices=new Uint16Array(decode(model.indices).buffer),expanded=[];
        const vertexAt=id=>{const o=id*16;return [view.getInt16(o,true)/32767*2,view.getInt16(o+2,true)/32767*2,view.getInt16(o+4,true)/32767*2,view.getInt8(o+6)/127,view.getInt8(o+7)/127,view.getInt8(o+8)/127,view.getUint16(o+10,true)/65535,view.getUint16(o+12,true)/65535];};
        for(let i=0;i<indices.length;i+=3){const triangle=[vertexAt(indices[i]),vertexAt(indices[i+1]),vertexAt(indices[i+2])];const center=[0,1,2].map(j=>triangle.reduce((sum,v)=>sum+v[j],0)/3),seed=((i/3*73)%907)/907;for(const v of triangle)expanded.push(...v,...center,seed);}
        this.vertexBuffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,this.vertexBuffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(expanded),gl.STATIC_DRAW);
        this.modelAttributes=['aPosition','aNormal','aUV','aCenter','aSeed'].map(name=>gl.getAttribLocation(program,name));
        this.count=indices.length;
        this.uniforms=Object.fromEntries(['uAngles','uCamera','uAspect','uLight','uMap','uHasTexture','uBlast','uFade'].map(name=>[name,gl.getUniformLocation(program,name)]));
        this.initStars(gl,compile);
        gl.useProgram(program);
        this.texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,this.texture);
        gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([128,128,128,255]));
        gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
        gl.uniform1i(this.uniforms.uMap,0);gl.uniform1f(this.uniforms.uHasTexture,0);
        gl.enable(gl.DEPTH_TEST);gl.disable(gl.CULL_FACE);gl.clearColor(0,0,0,0);
        this.resizeCanvas();this.measure();this.progress=this.target;this.draw();
        this.dataset.webgl='ready';this.querySelector('[data-orbit-pause]').hidden=false;this.queue();
        const poster=this.querySelector('.gzc-poster');
        if(poster){
          const image=new Image();image.crossOrigin='anonymous';
          image.onload=()=>{if(this.gl!==gl||this.program!==program||!this.isConnected)return;try{gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,image);gl.useProgram(program);gl.uniform1f(this.uniforms.uHasTexture,1);this.queue();}catch{}};
          image.src=poster.currentSrc||poster.src;
        }
      } catch {
        this.releaseGL();this.dataset.webgl='fallback';
      }
    }
    initStars(gl,compile){
      const vs=compile(gl.VERTEX_SHADER,`precision highp float;attribute vec4 aStar;uniform float uAspect;uniform float uTime;uniform vec2 uAim;uniform float uWarp;varying float vLight;void main(){vec3 p=aStar.xyz;p.x+=sin(uTime*.04+aStar.z)*.14+uAim.x*.6;p.y+=cos(uTime*.035+aStar.x)*.12+uAim.y*.5;p.z+=uWarp*6.;p.z=min(-.6,p.z);gl_Position=vec4(p.x*2./uAspect,p.y*2.,-1.002*p.z-.2,-p.z);gl_PointSize=(aStar.w+uWarp*2.)*1.5;vLight=.14+aStar.w*.12;}`);
      const fs=compile(gl.FRAGMENT_SHADER,`precision mediump float;varying float vLight;void main(){float d=length(gl_PointCoord-.5)*2.;float a=(1.-smoothstep(.1,1.,d))*vLight;gl_FragColor=vec4(vec3(a),a);}`);
      const program=gl.createProgram();gl.attachShader(program,vs);gl.attachShader(program,fs);gl.linkProgram(program);gl.deleteShader(vs);gl.deleteShader(fs);
      if(!gl.getProgramParameter(program,gl.LINK_STATUS)){gl.deleteProgram(program);return;}
      this.starProgram=program;this.starPosition=gl.getAttribLocation(program,'aStar');this.starUniforms=Object.fromEntries(['uAspect','uTime','uAim','uWarp'].map(n=>[n,gl.getUniformLocation(program,n)]));
      let seed=731;const random=()=>{seed=(seed*16807)%2147483647;return(seed-1)/2147483646};const data=[];this.starCount=innerWidth<750?100:180;for(let i=0;i<this.starCount;i++)data.push((random()-.5)*22,(random()-.5)*14,-2-random()*10,.65+random()*1.5);
      this.starBuffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,this.starBuffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(data),gl.STATIC_DRAW);
    }
    bindModel(){const gl=this.gl;gl.bindBuffer(gl.ARRAY_BUFFER,this.vertexBuffer);const sizes=[3,3,2,3,1],offsets=[0,12,24,32,44];this.modelAttributes.forEach((location,i)=>{gl.enableVertexAttribArray(location);gl.vertexAttribPointer(location,sizes[i],gl.FLOAT,false,48,offsets[i]);});}
    drawStars(warp=0){const gl=this.gl;if(!this.starProgram)return;this.modelAttributes.forEach(location=>gl.disableVertexAttribArray(location));gl.useProgram(this.starProgram);gl.bindBuffer(gl.ARRAY_BUFFER,this.starBuffer);gl.enableVertexAttribArray(this.starPosition);gl.vertexAttribPointer(this.starPosition,4,gl.FLOAT,false,16,0);gl.uniform1f(this.starUniforms.uAspect,this.aspect);gl.uniform1f(this.starUniforms.uTime,this.time);gl.uniform2f(this.starUniforms.uAim,this.pointer,this.pointerY);gl.uniform1f(this.starUniforms.uWarp,warp);gl.disable(gl.DEPTH_TEST);gl.enable(gl.BLEND);gl.blendFunc(gl.ONE,gl.ONE);gl.drawArrays(gl.POINTS,0,this.starCount);gl.disable(gl.BLEND);gl.enable(gl.DEPTH_TEST);gl.disableVertexAttribArray(this.starPosition);}
    resizeCanvas() {
      if (!this.gl) return;
      const rect=this.canvas.getBoundingClientRect();
      const ratio=Math.min(devicePixelRatio||1,innerWidth<750?1.25:1.5,Math.sqrt(1400000/Math.max(1,rect.width*rect.height)));
      const width=Math.max(1,Math.round(rect.width*ratio)),height=Math.max(1,Math.round(rect.height*ratio));
      if(this.canvas.width!==width||this.canvas.height!==height){this.canvas.width=width;this.canvas.height=height;this.gl.viewport(0,0,width,height);}
      this.aspect=width/height;
    }
    measure() {
      if(!this.enabled||this.paused||this.inTransit)return;
      this.target=Math.max(0,Math.min(1,-this.film.getBoundingClientRect().top/Math.max(1,this.film.offsetHeight-this.screen.offsetHeight)));
      this.queue();
    }
    queue(){
      if(!this.enabled||!this.visible||document.hidden||this.frame||this.paused||this.inTransit)return;
      this.frame=requestAnimationFrame(now=>{
        this.frame=0;if(now-(this.lastDraw||0)<32){this.queue();return;}const delta=Math.min(100,now-(this.lastDraw||now-33));this.lastDraw=now;this.time=now/1000;
        this.progress+=(this.target-this.progress)*(1-Math.exp(-delta/75));if(Math.abs(this.target-this.progress)<.0004)this.progress=this.target;
        this.pointer+=(this.aimX-this.pointer)*.12;this.pointerY+=(this.aimY-this.pointerY)*.12;
        this.updateCaptions(this.progress);if(this.gl)this.draw();if(this.gl||this.progress!==this.target||Math.abs(this.aimX-this.pointer)>.0004||Math.abs(this.aimY-this.pointerY)>.0004)this.queue();
      });
    }
    pose(progress) {
      const keys=[
        [0,.08,-.25,-.09,1.00,.24,.18,3.65],
        [.30,-.12,.12,.02,1.35,.12,.17,3.5],
        [.64,.20,2.85,-.12,1.2,-.16,.12,3.75],
        [1,0,6.10,0,1.70,0,.10,2.80]
      ];
      let i=0;while(i<keys.length-2&&progress>keys[i+1][0])i++;
      const a=keys[i],b=keys[i+1];let t=(progress-a[0])/(b[0]-a[0]);t=t*t*(3-2*t);
      return a.slice(1).map((value,j)=>value+(b[j+1]-value)*t);
    }
    draw(blast=0,transit=false){
      const gl=this.gl;if(!gl||!this.program)return;
      if(!transit)blast=Math.max(0,(this.progress-.74)/.26);
      const p=transit?this.pose(0):this.pose(this.progress),drift=transit?0:Math.sin(this.time*.35)*.045;
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);this.drawStars(blast);
      gl.useProgram(this.program);this.bindModel();
      gl.uniform3f(this.uniforms.uAngles,p[0]+this.pointerY,p[1]+this.pointer+drift,p[2]+Math.sin(this.time*.25)*.016);
      const mobile=innerWidth<750;
      gl.uniform4f(this.uniforms.uCamera,(transit?1.6+blast*1.2:p[3])*(mobile?.7:1),transit?0:p[4]*(mobile?.35:1),p[5]+Math.sin(this.time*.55)*.025,transit?3.05:p[6]);
      gl.uniform1f(this.uniforms.uAspect,this.aspect||1);gl.uniform1f(this.uniforms.uLight,this.progress+drift);gl.uniform1f(this.uniforms.uBlast,blast);gl.uniform1f(this.uniforms.uFade,1-Math.max(0,(blast-.55)/.45));
      gl.drawArrays(gl.TRIANGLES,0,this.count);
    }
    beginFracture(slot){
      if(!this.enabled||this.paused||!this.gl)return false;
      this.inTransit=true;cancelAnimationFrame(this.frame);this.frame=0;this.canvasHome=this.canvas.parentNode;this.canvasNext=this.canvas.nextSibling;slot.append(this.canvas);this.resizeCanvas();return true;
    }
    fracture(progress){if(this.gl)this.draw(Math.max(0,Math.min(1,(progress-.12)/.83)),true);}
    endFracture(){
      if(!this.inTransit)return;this.inTransit=false;
      if(this.canvasHome?.isConnected)this.canvasHome.insertBefore(this.canvas,this.canvasNext);
      this.resizeCanvas();this.measure();this.queue();
    }
    updateCaptions(progress) {
      const act=Math.min(3,Math.floor(progress*4));
      this.captions.forEach((caption,index)=>{
        const distance=Math.abs(progress-(index*.25+.105));
        const opacity=index===act?Math.max(.05,Math.min(1,(.15-distance)*22)):0;
        caption.style.opacity=String(progress===0&&index===0||progress===1&&index===3?1:opacity);
        caption.style.transform=`translateY(${index===act?(1-opacity)*14:18}px)`;
        caption.setAttribute('aria-hidden',String(index!==act));
      });
      this.screen.style.setProperty('--travel',String(progress));
      this.querySelector('[data-act]').textContent=String(act+1).padStart(2,'0');
      this.querySelector('[data-playhead]').style.transform=`scaleX(${progress})`;
      this.querySelector('.gzc-backtitle').style.transform=`translate3d(${-progress*7}%,${progress*45}px,0)`;
    }
    releaseGL() {
      if(this.gl){if(this.vertexBuffer)this.gl.deleteBuffer(this.vertexBuffer);if(this.indexBuffer)this.gl.deleteBuffer(this.indexBuffer);if(this.texture)this.gl.deleteTexture(this.texture);if(this.program)this.gl.deleteProgram(this.program);if(this.starProgram)this.gl.deleteProgram(this.starProgram);if(this.starBuffer)this.gl.deleteBuffer(this.starBuffer);}
      this.gl=null;this.program=null;
    }
    disconnectedCallback() {
      this.controller?.abort();this.observer?.disconnect();this.resize?.disconnect();
      cancelAnimationFrame(this.frame);if(this.idle&&'cancelIdleCallback' in window)cancelIdleCallback(this.idle);clearTimeout(this.initTimer);
      this.releaseGL();this.controller=null;this.frame=0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grindz-descent"] && !Shopify.designMode) return;
  try {
    
(function(){
  const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
  const smooth=(a,b,x)=>{const t=clamp((x-a)/(b-a));return t*t*(3-2*t);};
  const add=(a,b)=>a.map((v,i)=>v+b[i]),sub=(a,b)=>a.map((v,i)=>v-b[i]),mul=(a,s)=>a.map(v=>v*s);
  const dot=(a,b)=>a.reduce((v,n,i)=>v+n*b[i],0),cross=(a,b)=>[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];
  const norm=a=>mul(a,1/(Math.hypot(...a)||1));
  const identity=()=>[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];
  const multiply=(a,b)=>{const o=Array(16).fill(0);for(let c=0;c<4;c++)for(let r=0;r<4;r++)for(let k=0;k<4;k++)o[c*4+r]+=a[k*4+r]*b[c*4+k];return o;};
  const perspective=(fov,aspect,near,far)=>{const f=1/Math.tan(fov/2);return [f/aspect,0,0,0,0,f,0,0,0,0,(far+near)/(near-far),-1,0,0,2*far*near/(near-far),0];};
  const lookAt=(eye,target)=>{const z=norm(sub(eye,target)),x=norm(cross([0,1,0],z)),y=cross(z,x);return [x[0],y[0],z[0],0,x[1],y[1],z[1],0,x[2],y[2],z[2],0,-dot(x,eye),-dot(y,eye),-dot(z,eye),1];};
  const random=seed=>{let state=seed;return()=>{state=state*16807%2147483647;return(state-1)/2147483646;};};
  const path=[
    {p:0,e:[.7,9.5,29.2],t:[0,9.2,23]},
    {p:.20,e:[1.1,8.8,25.9],t:[0,8.1,18]},
    {p:.41,e:[-.8,5.1,17],t:[0,1.2,0]},
    {p:.61,e:[-1.25,1.2,9.6],t:[0,.15,0]},
    {p:.79,e:[0,.15,5.55],t:[0,0,0]},
    {p:.91,e:[0,.04,3.8],t:[0,0,-1]},
    {p:1,e:[0,0,-1.7],t:[0,0,-5]}
  ];
  function spline(p,key){
    let i=0;while(i<path.length-2&&p>path[i+1].p)i++;
    const a=path[i],b=path[i+1],prev=path[Math.max(0,i-1)],next=path[Math.min(path.length-1,i+2)],d=b.p-a.p,t=clamp((p-a.p)/d),t2=t*t,t3=t2*t;
    return a[key].map((v,k)=>{
      const m0=(b[key][k]-prev[key][k])/(b.p-prev.p),m1=(next[key][k]-a[key][k])/(next.p-a.p);
      return (2*t3-3*t2+1)*v+(t3-2*t2+t)*m0*d+(-2*t3+3*t2)*b[key][k]+(t3-t2)*m1*d;
    });
  }
  function state(progress,aspect=1.7,aim=[0,0]){
    const p=clamp(progress),target=spline(p,'t'),raw=spline(p,'e'),fit=Math.max(1,.65/aspect);
    const eye=add(target,mul(sub(raw,target),1+(fit-1)*(1-smooth(.9,1,p))));
    eye[0]+=aim[0]*.18*(1-smooth(.78,.92,p));eye[1]+=aim[1]*.1;
    return {p,eye,target,blast:smooth(.795,.955,p),reveal:smooth(.875,.994,p),atmosphere:smooth(.17,.36,p)*(1-smooth(.46,.64,p)),logo:1-smooth(.22,.37,p),pressure:smooth(.68,.795,p)};
  }
  class Mesh{
    constructor(){this.values=[];}
    vertex(position,normal,meta={},uv=[0,0]){
      const center=meta.center||[0,0,0],impulse=meta.impulse||[0,0,0];
      this.values.push(...position,...normal,...center,...impulse,meta.grey??.6,meta.kind||0,meta.seed||0,meta.metal??.8,...uv);
    }
    tri(a,b,c,meta={},normals){
      const n=norm(cross(sub(b,a),sub(c,a)));
      [a,b,c].forEach((p,i)=>this.vertex(p,normals?normals[i]:n,meta));
    }
    quad(a,b,c,d,m){this.tri(a,b,c,m);this.tri(a,c,d,m);}
    prism(poly,back,front,m={},bevel=.04){
      const c=poly.reduce((a,b)=>add(a,b),[0,0]).map(v=>v/poly.length);
      const inner=poly.map(p=>{const delta=sub(c,p),dist=Math.hypot(...delta);return add(p,mul(delta,Math.min(.18,bevel/(dist||1))));});
      const frontPoints=inner.map(p=>[...p,front]),backPoints=poly.map(p=>[...p,back]),edge=poly.map(p=>[...p,front-bevel]);
      for(let i=1;i<poly.length-1;i++){this.tri(frontPoints[0],frontPoints[i],frontPoints[i+1],m);this.tri(backPoints[0],backPoints[i+1],backPoints[i],m);}
      for(let i=0;i<poly.length;i++){const j=(i+1)%poly.length;this.quad(frontPoints[i],edge[i],edge[j],frontPoints[j],m);this.quad(edge[i],backPoints[i],backPoints[j],edge[j],m);}
    }
    box(x,y,z,w,h,d,m={},bevel=.025){this.prism([[x-w/2,y-h/2],[x+w/2,y-h/2],[x+w/2,y+h/2],[x-w/2,y+h/2]],z-d/2,z+d/2,m,bevel);}
    cylinder(a,b,r,m={},segments=12){
      const axis=norm(sub(b,a)),u=norm(cross(axis,Math.abs(axis[1])<.9?[0,1,0]:[1,0,0])),v=cross(axis,u);
      for(let i=0;i<segments;i++){
        const t=i/segments*Math.PI*2,t2=(i+1)/segments*Math.PI*2,n1=add(mul(u,Math.cos(t)),mul(v,Math.sin(t))),n2=add(mul(u,Math.cos(t2)),mul(v,Math.sin(t2)));
        const a1=add(a,mul(n1,r)),a2=add(a,mul(n2,r)),b1=add(b,mul(n1,r)),b2=add(b,mul(n2,r));
        this.tri(a1,a2,b2,m,[n1,n2,n2]);this.tri(a1,b2,b1,m,[n1,n2,n1]);this.tri(a,a2,a1,m);this.tri(b,b1,b2,m);
      }
    }
    ring(cx,cy,z,r,t,m,segments=32){for(let i=0;i<segments;i++){const a=i*Math.PI*2/segments,b=(i+1)*Math.PI*2/segments;this.cylinder([cx+Math.cos(a)*r,cy+Math.sin(a)*r,z],[cx+Math.cos(b)*r,cy+Math.sin(b)*r,z],t,m,5);}}
  }
  function clip(poly,n,c){
    const out=[];for(let i=0;i<poly.length;i++){
      const a=poly[i],b=poly[(i+1)%poly.length],da=dot(n,a)-c,db=dot(n,b)-c;
      if(da<=0)out.push(a);
      if((da<=0)!==(db<=0)){const t=da/(da-db);out.push(add(a,mul(sub(b,a),t)));}
    }return out;
  }
  function buildScene(){
    const mesh=new Mesh(),rnd=random(8291),steel={grey:.47,metal:.94},edge={grey:.8,metal:1},dark={grey:.11,metal:.55};
    mesh.box(-1.59,0,-.16,.28,3.9,1.78,steel,.06);mesh.box(1.59,0,-.16,.28,3.9,1.78,steel,.06);
    mesh.box(0,1.87,-.16,3.45,.26,1.78,steel,.05);mesh.box(0,-1.87,-.16,3.45,.26,1.78,steel,.05);
    mesh.box(0,0,-1.03,3.45,3.9,.12,dark);mesh.box(0,-2.09,-.1,4.1,.2,2.6,{grey:.16,metal:.7},.06);
    for(const x of [-1.42,1.42])mesh.box(x,0,.77,.065,3.47,.09,edge,.01);
    for(const y of [-1.72,1.72])mesh.box(0,y,.77,2.9,.065,.09,edge,.01);
    for(const x of [-1.6,1.6])for(const y of [-1.55,-.78,0,.78,1.55])mesh.cylinder([x,y,.74],[x,y,.84],.075,edge,6);
    for(const y of [-1.86,1.86])for(const x of [-.9,0,.9])mesh.cylinder([x,y,.74],[x,y,.84],.075,edge,6);
    const sites=[];for(let y=0;y<5;y++)for(let x=0;x<4;x++)sites.push([-1.38+(x+.25+rnd()*.5)*2.76/4,-1.67+(y+.25+rnd()*.5)*3.34/5]);
    sites.forEach((site,i)=>{
      let poly=[[-1.38,-1.67],[1.38,-1.67],[1.38,1.67],[-1.38,1.67]];
      for(const other of sites){if(other===site)continue;const n=sub(other,site),c=(dot(other,other)-dot(site,site))/2;poly=clip(poly,n,c);}
      const seed=rnd(),center=[...site,.79],impulse=[site[0]*2.5+(rnd()-.5)*1.7,site[1]*1.8+(rnd()-.3)*2,4.6+rnd()*5.8];
      mesh.prism(poly,.59,.91,{grey:.39+rnd()*.08,metal:.95,kind:1,seed,center,impulse},.028);
    });
    for(const y of [-1.14,.98])mesh.box(-1.37,y,.93,.25,.42,.18,{grey:.65,metal:1,kind:1,seed:.3+y*.06,center:[-1.37,y,.9],impulse:[-3,y,5]},.035);
    const wheel={grey:.83,metal:1,kind:1,seed:.42,center:[.6,.04,1.04],impulse:[2.4,.7,7.2]};
    mesh.ring(.57,.08,1.08,.45,.049,wheel,24);mesh.cylinder([.57,.08,.94],[.57,.08,1.19],.14,wheel,18);
    for(let n=0;n<3;n++){const a=n*Math.PI*2/3;mesh.cylinder([.57,.08,1.1],[.57+Math.cos(a)*.42,.08+Math.sin(a)*.42,1.1],.035,wheel,8);}
    for(let i=0;i<3;i++){
      const x=-1.01+i*.285,prop={grey:.23,metal:.25,kind:1,seed:.65+i*.06,center:[x,-.25,1.12],impulse:[-2+i*.5,-1+i,6.5+i]};
      mesh.cylinder([x,-.98,1.12],[x,.4,1.12],.125,prop,12);
      mesh.cylinder([x,.395,1.12],[x,.43,1.12],.126,{...prop,grey:.57,metal:.9},12);
      for(const y of [-.69,.11])mesh.cylinder([x,y-.045,1.12],[x,y+.045,1.12],.134,{...prop,grey:.7,metal:.8},12);
      const wire=[[x,.43,1.12],[x-.04,.58,1.15],[x+.09,.72,1.15],[x+.25,.63,1.15]];
      for(let j=0;j<wire.length-1;j++)mesh.cylinder(wire[j],wire[j+1],.013,{...prop,grey:.8,metal:.6},5);
    }
    const strap={grey:.52,metal:.9,kind:1,seed:.27,center:[-.73,-.3,1.3],impulse:[-3,1,7]};
    for(const y of [-.68,.1])mesh.box(-.725,y,1.25,.96,.085,.07,strap,.006);
    mesh.box(0,-2.25,9,9,.12,24,{grey:.08,metal:.6});
    for(let i=0;i<6;i++){
      const z=3.5+i*3.15,frame={grey:.18,metal:.9};
      for(const x of [-3.4,3.4])mesh.box(x,.4,z,.09,5.4,.10,frame,.015);
      mesh.box(0,3.12,z,6.9,.09,.10,frame,.015);
      for(const x of [-2.6,2.6])mesh.box(x,-2.15,z,.065,.035,2.6,{grey:.36,metal:.8},.005);
    }
    for(let i=0;i<42;i++){
      const x=(rnd()-.5)*2.6,y=(rnd()-.5)*3.1,size=.017+rnd()*.04;
      const meta={grey:.75,metal:1,kind:2,seed:rnd(),center:[x,y,1],impulse:[x*3+(rnd()-.5)*4,y*2+2,5+rnd()*8]};
      mesh.tri([x-size,y-size,1],[x+size,y,1.03],[x,y+size,1.02],meta);
    }
    return new Float32Array(mesh.values);
  }
  function decodeLogo(model){
    const decode=s=>typeof atob==='function'?Uint8Array.from(atob(s),c=>c.charCodeAt(0)):new Uint8Array(Buffer.from(s,'base64'));
    const bytes=decode(model.data),view=new DataView(bytes.buffer,bytes.byteOffset,bytes.byteLength),indicesBytes=decode(model.indices),indices=new DataView(indicesBytes.buffer,indicesBytes.byteOffset,indicesBytes.byteLength),mesh=new Mesh();
    for(let i=0;i<indices.byteLength;i+=2){
      const o=indices.getUint16(i,true)*16;
      mesh.vertex([view.getInt16(o,true)/32767*2,view.getInt16(o+2,true)/32767*2,view.getInt16(o+4,true)/32767*2],[view.getInt8(o+6)/127,view.getInt8(o+7)/127,view.getInt8(o+8)/127],{grey:.8,metal:1},[view.getUint16(o+10,true)/65535,view.getUint16(o+12,true)/65535]);
    }return new Float32Array(mesh.values);
  }
  const vertex=[
    'precision highp float;',
    'attribute vec3 aPosition;attribute vec3 aNormal;attribute vec3 aCenter;attribute vec3 aImpulse;attribute vec4 aExtra;attribute vec2 aUV;',
    'uniform mat4 uVP;uniform mat4 uModel;uniform mediump float uBlast;uniform float uProgress;',
    'varying mediump vec3 vWorld;varying mediump vec3 vNormal;varying mediump vec4 vExtra;varying mediump vec2 vUV;',
    'vec3 rotateAxis(vec3 v,vec3 a,float angle){float c=cos(angle),s=sin(angle);return v*c+cross(a,v)*s+a*dot(a,v)*(1.-c);}',
    'void main(){',
    'float moving=step(.5,aExtra.y);float b=uBlast*moving;vec3 axis=normalize(vec3(sin(aExtra.z*32.)+.2,cos(aExtra.z*47.)+.3,sin(aExtra.z*71.)+.4));',
    'float angle=b*(aExtra.z*7.+1.3);vec3 pos=aCenter+rotateAxis(aPosition-aCenter,axis,angle)+aImpulse*b+vec3(0.,-b*b*3.,0.);',
    'pos.x+=moving*sin(uProgress*180.+aExtra.z*30.)*smoothstep(.69,.79,uProgress)*(1.-step(.02,uBlast))*.008;',
    'vec4 world=uModel*vec4(pos,1.);vWorld=world.xyz;vNormal=mat3(uModel)*rotateAxis(aNormal,axis,angle);vExtra=aExtra;vUV=aUV;',
    'gl_Position=uVP*world;}'
  ].join('\n');
  const fragment=[
    'precision mediump float;',
    'uniform vec3 uEye;uniform float uOpacity;uniform float uReveal;uniform mediump float uBlast;uniform float uAtmosphere;uniform float uUseMap;uniform sampler2D uMap;',
    'varying mediump vec3 vWorld;varying mediump vec3 vNormal;varying mediump vec4 vExtra;varying mediump vec2 vUV;',
    'void main(){',
    'vec3 n=normalize(vNormal);if(!gl_FrontFacing)n=-n;vec3 v=normalize(uEye-vWorld),r=reflect(-v,n);',
    'float fresnel=pow(1.-max(0.,dot(n,v)),3.);float panel=pow(max(0.,1.-abs(r.x*.52+r.y*.84-.15)),32.);',
    'float soft=pow(max(0.,dot(r,normalize(vec3(-.4,.8,.6)))),4.);float strip=pow(max(0.,dot(r,normalize(vec3(.7,.1,.8)))),65.);',
    'float metal=(.065+soft*.62+panel*.88+strip*.9+fresnel*.23)*vExtra.x;',
    'float diffuse=(.12+max(0.,dot(n,normalize(vec3(-.5,1.,1.))))*.62)*vExtra.x;',
    'float grey=mix(diffuse,metal,vExtra.w);grey+=sin(vWorld.y*165.+vWorld.x*7.)*.001;',
    'if(uUseMap>.5&&abs(vNormal.z)>.4){float tex=dot(texture2D(uMap,vUV).rgb,vec3(.3333));grey=mix(grey,tex*.82+grey*.25,.83);}',
    'float fog=1.-exp(-length(uEye-vWorld)*(.012+uAtmosphere*.072));grey=mix(grey,.038+uAtmosphere*.08,fog);',
    'float alpha=uOpacity*(1.-uReveal);if(vExtra.y>.5)alpha=uOpacity*(1.-smoothstep(.78,1.,uBlast));',
    'if(vExtra.y>1.5)alpha*=smoothstep(.005,.08,uBlast);if(alpha<.006)discard;',
    'gl_FragColor=vec4(vec3(clamp(grey,0.,1.)),alpha);}'
  ].join('\n');
  const backgroundVertex='attribute vec2 aPosition;varying mediump vec2 vUV;void main(){vUV=aPosition;gl_Position=vec4(aPosition,1.,1.);}';
  const backgroundFragment=[
    'precision mediump float;varying mediump vec2 vUV;uniform float uAspect;uniform float uProgress;uniform float uReveal;uniform float uAtmosphere;',
    'float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*437.58);}',
    'float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.)),f.x),f.y);}',
    'void main(){vec2 uv=vUV;uv.x*=uAspect;',
    'float horizon=.16+uv.x*uv.x*.10+(uProgress-.38)*1.65;float band=exp(-abs(uv.y-horizon)*8.);',
    'float clouds=noise(uv*3.+vec2(uProgress*8.,-uProgress*10.))*.55+noise(uv*7.+uProgress*12.)*.25;',
    'float grey=.004+exp(-length(uv-vec2(.15,.2))*2.8)*.019+uAtmosphere*(band*.25+clouds*.10);',
    'grey+=exp(-length(uv)*2.)*sin(smoothstep(.795,.955,uProgress)*3.14159)*.12;',
    'gl_FragColor=vec4(vec3(grey),1.-uReveal);}'
  ].join('\n');
  const starVertex='precision highp float;attribute vec4 aStar;uniform mat4 uVP;uniform float uOpacity;varying mediump float vOpacity;void main(){gl_Position=uVP*vec4(aStar.xyz,1.);gl_PointSize=aStar.w;vOpacity=uOpacity*(.25+aStar.w*.08);}';
  const starFragment='precision mediump float;varying mediump float vOpacity;void main(){float a=(1.-smoothstep(.1,.5,length(gl_PointCoord-.5)))*vOpacity;gl_FragColor=vec4(vec3(.64),a);}';
  function shaderProgram(gl,vs,fs){
    const compile=(type,source)=>{const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS)){const error=gl.getShaderInfoLog(s);gl.deleteShader(s);throw Error(error);}return s;};
    let v,f,program;try{v=compile(gl.VERTEX_SHADER,vs);f=compile(gl.FRAGMENT_SHADER,fs);program=gl.createProgram();gl.attachShader(program,v);gl.attachShader(program,f);gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error(gl.getProgramInfoLog(program));return program;}catch(e){if(program)gl.deleteProgram(program);throw e;}finally{if(v)gl.deleteShader(v);if(f)gl.deleteShader(f);}
  }
  function logoMatrix(p){const angle=p*3.6-.18,c=Math.cos(angle),sn=Math.sin(angle),z=-.13,cz=Math.cos(z),sz=Math.sin(z);
        const ry=[c,0,-sn,0,0,1,0,0,sn,0,c,0,0,0,0,1],rz=[cz,sz,0,0,-sz,cz,0,0,0,0,1,0,0,0,0,1],m=multiply(rz,ry);for(const i of [0,1,2,4,5,6,8,9,10])m[i]*=1.38;m[12]=0;m[13]=9.2;m[14]=23;return m;}
  class Renderer{
    constructor(canvas,model){
      this.canvas=canvas;this.buffers=[];this.programs=[];const gl=canvas.getContext('webgl',{alpha:true,antialias:false,depth:true,stencil:false,premultipliedAlpha:true,powerPreference:'low-power'});
      if(!gl)throw Error('WebGL unavailable');this.gl=gl;this.attributeCount=gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
      try{
        this.modelProgram=shaderProgram(gl,vertex,fragment);this.programs.push(this.modelProgram);
        this.modelAttributes=['aPosition','aNormal','aCenter','aImpulse','aExtra','aUV'].map(n=>gl.getAttribLocation(this.modelProgram,n));
        this.uniforms=Object.fromEntries(['uVP','uModel','uBlast','uProgress','uEye','uOpacity','uReveal','uAtmosphere','uUseMap','uMap'].map(n=>[n,gl.getUniformLocation(this.modelProgram,n)]));
        this.scene=this.buffer(buildScene(),18);this.logo=this.buffer(decodeLogo(model),18);
        this.backgroundProgram=shaderProgram(gl,backgroundVertex,backgroundFragment);this.programs.push(this.backgroundProgram);
        this.backgroundPosition=gl.getAttribLocation(this.backgroundProgram,'aPosition');this.backgroundUniforms=Object.fromEntries(['uAspect','uProgress','uReveal','uAtmosphere'].map(n=>[n,gl.getUniformLocation(this.backgroundProgram,n)]));this.background=this.buffer(new Float32Array([-1,-1,3,-1,-1,3]),2);
        this.starProgram=shaderProgram(gl,starVertex,starFragment);this.programs.push(this.starProgram);this.starPosition=gl.getAttribLocation(this.starProgram,'aStar');this.starUniforms={uVP:gl.getUniformLocation(this.starProgram,'uVP'),uOpacity:gl.getUniformLocation(this.starProgram,'uOpacity')};
        const rnd=random(1928),stars=[];for(let i=0;i<180;i++)stars.push((rnd()-.5)*65,2+rnd()*34,7-rnd()*45,.6+rnd()*1.6);this.stars=this.buffer(new Float32Array(stars),4);
        this.texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([155,155,155,255]));gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
        gl.disable(gl.CULL_FACE);gl.enable(gl.BLEND);gl.blendFuncSeparate(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA,gl.ONE,gl.ONE_MINUS_SRC_ALPHA);gl.clearColor(0,0,0,0);this.resize();
      }catch(e){this.dispose();throw e;}
    }
    buffer(data,stride){const gl=this.gl,b=gl.createBuffer();this.buffers.push(b);gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,data,gl.STATIC_DRAW);return {buffer:b,count:data.length/stride};}
    setTexture(image){const gl=this.gl;if(!gl)return;gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,image);this.hasTexture=true;}
    resize(){const gl=this.gl;if(!gl)return;const w=Math.max(1,this.canvas.clientWidth),h=Math.max(1,this.canvas.clientHeight),ratio=Math.min(typeof devicePixelRatio==='number'?devicePixelRatio:1,w<750?1.15:1.35,Math.sqrt(1050000/(w*h)));const width=Math.round(w*ratio),height=Math.round(h*ratio);if(this.canvas.width!==width)this.canvas.width=width;if(this.canvas.height!==height)this.canvas.height=height;this.aspect=w/h;gl.viewport(0,0,this.canvas.width,this.canvas.height);}
    clearAttributes(){const gl=this.gl;for(let i=0;i<this.attributeCount;i++)gl.disableVertexAttribArray(i);}
    mesh(data,matrix,s,opacity=1,useMap=false){
      const gl=this.gl;this.clearAttributes();gl.useProgram(this.modelProgram);gl.bindBuffer(gl.ARRAY_BUFFER,data.buffer);
      const sizes=[3,3,3,3,4,2],offsets=[0,12,24,36,48,64];this.modelAttributes.forEach((loc,i)=>{if(loc>=0){gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,sizes[i],gl.FLOAT,false,72,offsets[i]);}});
      const u=this.uniforms;gl.uniformMatrix4fv(u.uVP,false,this.vp);gl.uniformMatrix4fv(u.uModel,false,new Float32Array(matrix));gl.uniform3fv(u.uEye,new Float32Array(s.eye));gl.uniform1f(u.uBlast,useMap?0:s.blast);gl.uniform1f(u.uProgress,s.p);gl.uniform1f(u.uOpacity,opacity);gl.uniform1f(u.uReveal,s.reveal);gl.uniform1f(u.uAtmosphere,s.atmosphere);gl.uniform1f(u.uUseMap,useMap&&this.hasTexture?1:0);gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.uniform1i(u.uMap,0);gl.drawArrays(gl.TRIANGLES,0,data.count);
    }
    draw(progress,aim=[0,0]){
      const gl=this.gl;if(!gl)return;const s=state(progress,this.aspect,aim);this.vp=new Float32Array(multiply(perspective(55*Math.PI/180,this.aspect,.055,180),lookAt(s.eye,s.target)));
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.disable(gl.DEPTH_TEST);this.clearAttributes();gl.useProgram(this.backgroundProgram);gl.bindBuffer(gl.ARRAY_BUFFER,this.background.buffer);gl.enableVertexAttribArray(this.backgroundPosition);gl.vertexAttribPointer(this.backgroundPosition,2,gl.FLOAT,false,8,0);
      for(const [n,v] of Object.entries({uAspect:this.aspect,uProgress:s.p,uReveal:s.reveal,uAtmosphere:s.atmosphere}))gl.uniform1f(this.backgroundUniforms[n],v);gl.drawArrays(gl.TRIANGLES,0,3);
      if(s.p<.5){this.clearAttributes();gl.useProgram(this.starProgram);gl.bindBuffer(gl.ARRAY_BUFFER,this.stars.buffer);gl.enableVertexAttribArray(this.starPosition);gl.vertexAttribPointer(this.starPosition,4,gl.FLOAT,false,16,0);gl.uniformMatrix4fv(this.starUniforms.uVP,false,this.vp);gl.uniform1f(this.starUniforms.uOpacity,(1-smooth(.16,.48,s.p))*(1-s.reveal));gl.drawArrays(gl.POINTS,0,this.stars.count);}
      gl.enable(gl.DEPTH_TEST);
      if(s.p>.20)this.mesh(this.scene,identity(),s,smooth(.20,.36,s.p));
      if(s.logo>.001){
        this.mesh(this.logo,logoMatrix(s.p),s,s.logo,true);
      }return s;
    }
    dispose(){const gl=this.gl;if(!gl)return;this.buffers.forEach(b=>gl.deleteBuffer(b));this.programs.forEach(p=>gl.deleteProgram(p));if(this.texture)gl.deleteTexture(this.texture);this.buffers=[];this.programs=[];this.gl=null;}
  }
  const api={Renderer,state,logoMatrix,buildScene,decodeLogo,identity,multiply,perspective,lookAt,shaders:{vertex,fragment,backgroundVertex,backgroundFragment,starVertex,starFragment}};
  if(typeof window!=='undefined')window.GrindzDescentScene=api;if(typeof module==='object'&&module.exports)module.exports=api;
})();

if(!customElements.get('grindz-descent'))customElements.define('grindz-descent',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();const signal=this.controller.signal;
    this.stage=this.querySelector('[data-stage]');this.canvas=this.stage.querySelector('canvas');this.drop=document.getElementById('GrindzDrop');
    this.poster=this.querySelector('[data-poster] img');this.captions=[...this.stage.querySelectorAll('[data-scene]')];this.progress=0;this.target=0;this.aim=[0,0];this.pointer=[0,0];
    this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.coarse=matchMedia('(pointer:coarse)');this.optOut=false;
    document.body.append(this.stage);
    const apply=()=>{
      this.enabled=this.dataset.motion==='true'&&!this.reduced.matches&&!navigator.connection?.saveData&&!this.optOut&&!!this.drop;
      if(this.enabled){
        this.dataset.enhanced='true';
        if(!this.renderer)this.initialize();
        if(this.renderer){this.stage.hidden=false;this.resize();this.measure();this.queue();}
      }else{this.stopAuto();this.stopFrame();this.stage.hidden=true;this.dataset.enhanced='false';}
    };
    this.reduced.addEventListener('change',apply,{signal});navigator.connection?.addEventListener?.('change',apply,{signal});
    window.addEventListener('scroll',()=>this.measure(),{passive:true,signal});
    window.addEventListener('resize',()=>{this.resize();this.measure();},{passive:true,signal});
    window.visualViewport?.addEventListener('resize',()=>{this.resize();this.measure();},{passive:true,signal});
    this.resizeObserver=new ResizeObserver(()=>{this.resize();this.measure();});this.resizeObserver.observe(this);
    this.stage.addEventListener('pointermove',event=>{
      if(this.coarse.matches||!this.enabled)return;
      this.aim=[event.clientX/innerWidth*2-1,1-event.clientY/innerHeight*2];this.queue();
    },{passive:true,signal});
    this.stage.addEventListener('pointerleave',()=>{this.aim=[0,0];this.queue();},{signal});
    for(const event of ['wheel','touchstart'])window.addEventListener(event,()=>this.stopAuto(),{passive:true,signal});
    window.addEventListener('keydown',event=>{
      if(['Escape','ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key))this.stopAuto();
    },{signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden){this.stopFrame();this.stopAuto();}else{this.measure();this.queue();}},{signal});
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[data-vault-link],a[data-descent-skip]');
      if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.altKey||event.shiftKey||link.hasAttribute('download')||(link.target&&link.target!=='_self')||!this.enabled||!this.renderer)return;
      const url=new URL(link.href,location.href);if(url.origin!==location.origin)return;
      event.preventDefault();
      if(link.hasAttribute('data-descent-skip'))this.skip();else this.enter();
    },{signal});
    this.stage.querySelector('[data-descent-motion]').addEventListener('click',()=>{this.optOut=true;apply();this.drop?.scrollIntoView({behavior:'instant',block:'start'});this.drop?.focus({preventScroll:true});},{signal});
    document.addEventListener('grindz:drop-state',event=>{const el=this.stage.querySelector('[data-drop-status]');if(el)el.textContent=event.detail.label;},{signal});
    this.canvas.addEventListener('webglcontextlost',event=>{
      event.preventDefault();this.stopFrame();this.stopAuto();this.renderer=null;this.stage.hidden=true;this.dataset.enhanced='false';this.dataset.render='context-lost';
    },{signal});
    this.canvas.addEventListener('webglcontextrestored',()=>{if(this.enabled){this.dataset.enhanced='true';this.stage.hidden=false;this.initialize();this.resize();this.measure();}},{signal});
    window.addEventListener('pageshow',()=>{this.measure();this.queue();},{signal});
    apply();
  }
  initialize(){
    try{
      const model=JSON.parse(this.querySelector('[data-logo-model]').textContent);
      this.renderer=new window.GrindzDescentScene.Renderer(this.canvas,model);this.dataset.render='webgl';
      this.measure();this.progress=this.target;this.render();
      if(this.poster){
        const texture=new Image();texture.crossOrigin='anonymous';
        texture.onload=()=>{if(!this.renderer||!this.isConnected)return;try{this.renderer.setTexture(texture);this.queue();}catch{}};
        texture.src=this.poster.currentSrc||this.poster.src;
      }
    }catch(error){
      this.renderer?.dispose();this.renderer=null;this.dataset.render='fallback';this.dataset.enhanced='false';this.stage.hidden=true;
      console.warn('[Grindz] Scene unavailable:',error.message);
    }
  }
  resize(){if(this.renderer){this.renderer.resize();this.queue();}}
  measure(){
    if(!this.enabled||!this.drop)return;
    const top=this.getBoundingClientRect().top,toDrop=this.drop.getBoundingClientRect().top;
    this.range=Math.max(1,toDrop-top);this.target=Math.max(0,Math.min(1,-top/this.range));
    this.stage.style.setProperty('--navigation-top',Math.max(18,top+18)+'px');
    this.queue();
  }
  queue(){
    if(this.frame||!this.enabled||!this.renderer||document.hidden)return;
    this.frame=requestAnimationFrame(now=>{
      this.frame=0;const dt=Math.min(50,Math.max(8,now-(this.lastFrame||now-16)));this.lastFrame=now;
      const ease=1-Math.exp(-dt/45);this.progress+=(this.target-this.progress)*ease;
      if(Math.abs(this.target-this.progress)<.00015)this.progress=this.target;
      for(let i=0;i<2;i++){this.pointer[i]+=(this.aim[i]-this.pointer[i])*ease;if(Math.abs(this.aim[i]-this.pointer[i])<.0005)this.pointer[i]=this.aim[i];}
      this.render();
      if(this.progress!==this.target||this.pointer.some((p,i)=>p!==this.aim[i]))this.queue();
    });
  }
  render(){
    const p=this.progress,s=this.renderer.draw(p,this.pointer),arrived=p>=.9995;
    this.stage.hidden=arrived;this.stage.dataset.phase=p<.22?'orbit':p<.48?'atmosphere':p<.795?'safe':p<.955?'fracture':'arrival';
    this.stage.style.setProperty('--reveal',String(s.reveal));this.stage.style.setProperty('--pressure',String(s.pressure));
    this.stage.style.setProperty('--progress',String(p));this.stage.querySelector('[data-descent-percent]').textContent=String(Math.round(p*100)).padStart(3,'0');
    const ranges=[[0,.04,.16,.24],[.22,.28,.40,.48],[.47,.55,.68,.77],[.72,.77,.81,.875]];
    const smooth=(a,b,v)=>{const t=Math.max(0,Math.min(1,(v-a)/(b-a)));return t*t*(3-2*t);};
    this.captions.forEach((el,i)=>{
      const [a,b,c,d]=ranges[i],opacity=(i===0?1:smooth(a,b,p))*(1-smooth(c,d,p));
      el.style.opacity=String(opacity);el.style.transform='translate3d(0,'+((1-opacity)*25)+'px,0)';el.setAttribute('aria-hidden',opacity<.5?'true':'false');
    });
  }
  enter(){
    if(!this.enabled||!this.renderer){this.drop?.scrollIntoView({behavior:'instant',block:'start'});return;}
    this.stopAuto();const start=scrollY,end=scrollY+this.drop.getBoundingClientRect().top,distance=end-start;
    if(Math.abs(distance)<2){this.skip();return;}
    const duration=Math.min(2000,1050+Math.abs(distance)/3),began=performance.now();
    const step=now=>{
      const t=Math.min(1,(now-began)/duration),e=t*t*(3-2*t);window.scrollTo({top:start+distance*e,behavior:'instant'});
      this.measure();
      if(t<1)this.autoFrame=requestAnimationFrame(step);
      else{this.autoFrame=0;this.drop.focus({preventScroll:true});try{history.replaceState(history.state,'','#GrindzDrop');}catch{}}
    };
    this.autoFrame=requestAnimationFrame(step);
  }
  skip(){
    this.stopAuto();window.scrollTo({top:scrollY+this.drop.getBoundingClientRect().top,behavior:'instant'});
    this.target=1;this.progress=1;this.render();this.drop.focus({preventScroll:true});try{history.replaceState(history.state,'','#GrindzDrop');}catch{}
  }
  stopAuto(){cancelAnimationFrame(this.autoFrame);this.autoFrame=0;}
  stopFrame(){cancelAnimationFrame(this.frame);this.frame=0;this.lastFrame=0;}
  disconnectedCallback(){
    this.stopFrame();this.stopAuto();this.controller?.abort();this.resizeObserver?.disconnect();this.renderer?.dispose();this.renderer=null;this.stage?.remove();this.controller=null;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grindz-drop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grindz-story')) {
  customElements.define('grindz-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.fine = matchMedia('(hover: hover) and (pointer: fine)');
      this.track = this.querySelector('[data-hero-track]');
      this.hero = this.querySelector('[data-hero]');
      this.emblem = this.querySelector('[data-emblem]');
      this.rail = this.querySelector('[data-rail]');
      this.launch = this.querySelector('[data-launch]');
      this.drop = this.querySelector('[data-drop]');
      this.clock = this.querySelector('[data-countdown]');
      this.lastFetch = Date.now();
      this.failures = 0;
      this.x = 0; this.y = 0;
      this.end = this.parseDate(this.dataset.date);
      this.formatDate();
      const applyMotion = () => {
        this.motion = this.dataset.motion === 'true' && !this.reduced.matches && !navigator.connection?.saveData;
        this.dataset.animated = String(this.motion);
        if (!this.motion) {
          this.emblem.style.transform = '';
          this.querySelector('.gzi-hero__word').style.transform = '';
        }
        this.draw();
      };
      applyMotion();
      this.reduced.addEventListener('change', applyMotion, {signal});
      const scheduleDraw = () => {
        if (!this.motion || !this.heroVisible || document.hidden || this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.draw(); });
      };
      window.addEventListener('scroll', scheduleDraw, {passive:true, signal});
      window.addEventListener('resize', scheduleDraw, {passive:true, signal});
      this.hero.addEventListener('pointermove', event => {
        if (!this.motion || !this.fine.matches || event.pointerType === 'touch') return;
        const rect = this.hero.getBoundingClientRect();
        this.x = (event.clientX - rect.left) / rect.width - .5;
        this.y = (event.clientY - rect.top) / rect.height - .5;
        scheduleDraw();
      }, {passive:true, signal});
      this.hero.addEventListener('pointerleave', () => {this.x = 0; this.y = 0; scheduleDraw();}, {signal});
      this.visibility = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === this.track) this.heroVisible = entry.isIntersecting;
          if (entry.target === this.launch) this.clockVisible = entry.isIntersecting;
          if (entry.target === this.drop) this.dropVisible = entry.isIntersecting;
        }
        scheduleDraw(); this.tick(); this.scheduleStock();
      });
      [this.track, this.launch, this.drop].forEach(el => this.visibility.observe(el));
      const scenes = [...this.querySelectorAll('[data-scene]')];
      this.scenes = new IntersectionObserver(entries => {
        for (const entry of entries) {
          entry.target.dataset.active = String(entry.isIntersecting);
          if (entry.isIntersecting) this.querySelector('[data-scene-number]').textContent = entry.target.dataset.scene;
        }
      }, {rootMargin:'-20% 0px -30% 0px', threshold:0});
      scenes.forEach(scene => this.scenes.observe(scene));
      this.bindRail();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-detail-toggle]');
        if (!button) return;
        const active = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(active));
        button.closest('[data-product]').dataset.detail = String(active);
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {this.request?.abort(); cancelAnimationFrame(this.frame); this.frame = 0;}
        this.tick(); this.scheduleStock(); scheduleDraw();
      }, {signal});
      window.addEventListener('online', () => this.scheduleStock(), {signal});
      this.tick();
    }
    parseDate(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [,year,month,day,hour,minute,second,zone] = match;
      const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);
      if (!Number.isFinite(+date) || date.toISOString().slice(0,19) !== value.slice(0,19)) return NaN;
      if (zone !== 'Z' && (+zone.slice(1,3) > 14 || +zone.slice(4) > 59 || (+zone.slice(1,3) === 14 && +zone.slice(4) !== 0))) return NaN;
      return Date.parse(value);
    }
    formatDate() {
      const display = this.querySelector('[data-date-display]');
      if (!Number.isFinite(this.end)) {display.textContent = this.querySelector('[data-no-date]').textContent; return;}
      const value = this.dataset.date;
      const local = new Date(value.slice(0,19) + 'Z');
      const text = new Intl.DateTimeFormat('es-CR', {dateStyle:'long', timeStyle:'short', timeZone:'UTC', hour12:false}).format(local);
      const time = document.createElement('time');
      time.dateTime = value;
      time.textContent = text + ' · UTC' + (value.endsWith('Z') ? '+00:00' : value.slice(-6));
      display.replaceChildren(time);
    }
    tick() {
      clearTimeout(this.clockTimer);
      const remaining = Number.isFinite(this.end) ? Math.max(0, Math.ceil((this.end - Date.now()) / 1000)) : 0;
      const previous = this.dataset.dropState;
      const state = this.dataset.closed === 'true' ? 'closed' : remaining > 0 ? 'scheduled' : this.dataset.hasProducts === 'true' ? 'active' : Number.isFinite(this.end) ? 'opening' : 'announced';
      this.dataset.dropState = state;
      this.clock.hidden = state !== 'scheduled';
      if (previous === 'scheduled' && state !== previous) {
        this.querySelector('[data-announcement]').textContent = this.querySelector(`[data-status="${state}"]`).textContent;
        this.lastFetch = 0;
        this.scheduleStock();
      }
      if (state === 'scheduled') {
        const values = {days:Math.floor(remaining / 86400), hours:Math.floor(remaining / 3600) % 24, minutes:Math.floor(remaining / 60) % 60, seconds:remaining % 60};
        for (const [unit, value] of Object.entries(values)) {
          const node = this.querySelector(`[data-time="${unit}"]`);
          const text = String(value).padStart(2,'0');
          if (node.textContent !== text) node.textContent = text;
        }
        if (!document.hidden) this.clockTimer = setTimeout(() => this.tick(), this.clockVisible ? 1000 : Math.min(60000, remaining * 1000));
      }
    }
    draw() {
      if (!this.motion) return;
      const distance = Math.max(1, this.track.offsetHeight - this.hero.offsetHeight);
      const progress = Math.min(1, Math.max(0, -this.track.getBoundingClientRect().top / distance));
      this.emblem.style.transform = `translate3d(${progress * 30}px,${-progress * 55}px,0) rotateX(${-9 + progress * 21 - this.y * 6}deg) rotateY(${-17 + progress * 62 + this.x * 12}deg) rotateZ(${-7 - progress * 13}deg) scale(${1 - progress * .16})`;
      this.querySelector('.gzi-hero__word').style.transform = `translate3d(${-progress * 5}%,${progress * 38}px,0)`;
      this.querySelector('.gzi-stage__lines').style.opacity = String(progress * .55);
      this.querySelector('.gzi-shard--a').style.transform = `translate3d(0,${progress * 95}px,0) rotate(${24 + progress * 55}deg)`;
      this.querySelector('.gzi-shard--b').style.transform = `translate3d(0,${-progress * 65}px,0) rotate(${-28 - progress * 45}deg)`;
      this.querySelector('[data-scroll-line]').style.transform = `scaleX(${progress})`;
    }
    bindRail() {
      this.rail = this.querySelector('[data-rail]');
      if (!this.rail) return;
      const signal = this.controller.signal;
      this.querySelector('[data-rail-controls]').hidden = false;
      this.querySelectorAll('[data-detail-toggle]').forEach(button => {button.hidden = false;});
      this.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
        this.rail.scrollBy({left:Number(button.dataset.railStep) * this.rail.clientWidth * .78, behavior:this.reduced.matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.rail.addEventListener('scroll', () => this.updateRail(), {passive:true, signal});
      this.updateRail();
    }
    updateRail() {
      if (!this.rail) return;
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      this.querySelector('[data-rail-step="-1"]').disabled = this.rail.scrollLeft <= 2;
      this.querySelector('[data-rail-step="1"]').disabled = this.rail.scrollLeft >= max - 2;
    }
    scheduleStock() {
      clearTimeout(this.stockTimer);
      if (!this.isConnected || this.dataset.refresh !== 'true' || !this.dropVisible || document.hidden || navigator.onLine === false || this.dataset.closed === 'true' || this.dataset.dropState === 'scheduled' || this.dataset.dropState === 'announced' || this.request) return;
      const interval = navigator.connection?.saveData ? 120000 : Math.min(240000, 45000 * 2 ** this.failures);
      this.stockTimer = setTimeout(() => this.refreshStock(), Math.max(0, interval - (Date.now() - this.lastFetch)));
    }
    async refreshStock() {
      if (this.request || document.hidden || !this.dropVisible) return;
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 8000);
      try {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', this.dataset.section);
        const response = await fetch(url, {signal:request.signal, credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Section unavailable');
        const sections = await response.json();
        const html = sections[this.dataset.section];
        if (typeof html !== 'string' || !html) throw new Error('Section missing');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById(this.id);
        if (!fresh) throw new Error('Section mismatch');
        let cards = [...this.querySelectorAll('[data-product]')];
        const freshCards = new Map([...fresh.querySelectorAll('[data-product]')].map(card => [card.dataset.product, card]));
        if (freshCards.size !== cards.length || cards.some(card => !freshCards.has(card.dataset.product))) {
          const target = this.querySelector('[data-lookbook]');
          const source = fresh.querySelector('[data-lookbook]');
          if (!target || !source) throw new Error('Lookbook missing');
          const hadFocus = target.contains(document.activeElement);
          const focusedProduct = document.activeElement.closest('[data-product]')?.dataset.product;
          const scroll = this.rail?.scrollLeft || 0;
          target.replaceChildren(...[...source.childNodes].map(node => document.importNode(node, true)));
          this.bindRail();
          if (this.rail) this.rail.scrollLeft = scroll;
          if (hadFocus) {
            const card = [...this.querySelectorAll('[data-product]')].find(item => item.dataset.product === focusedProduct);
            const focus = card?.querySelector('a') || this.querySelector('[data-launch] a');
            focus?.focus({preventScroll:true});
          }
          cards = [...this.querySelectorAll('[data-product]')];
        }
        for (const card of cards) {
          const updated = freshCards.get(card.dataset.product);
          const target = card.querySelector('[data-stock]');
          const source = updated.querySelector('[data-stock]');
          if (!target || !source) throw new Error('Stock missing');
          card.dataset.available = updated.dataset.available;
          if (target.innerHTML !== source.innerHTML) {
            const hadFocus = target.contains(document.activeElement);
            target.replaceChildren(...[...source.childNodes].map(node => document.importNode(node, true)));
            if (hadFocus) target.querySelector('a')?.focus({preventScroll:true});
          }
        }
        this.dataset.hasProducts = fresh.dataset.hasProducts;
        this.dataset.closed = fresh.dataset.closed;
        this.failures = 0;
        const note = this.querySelector('[data-stock-note]');
        if (note) note.textContent = note.dataset.fresh + ' ' + new Intl.DateTimeFormat('es-CR',{hour:'2-digit',minute:'2-digit',second:'2-digit'}).format(new Date());
        this.tick();
      } catch {
        this.failures = Math.min(3, this.failures + 1);
        const note = this.querySelector('[data-stock-note]');
        if (note && !document.hidden) note.textContent = note.dataset.stale;
      } finally {
        clearTimeout(timeout);
        this.request = null;
        this.lastFetch = Date.now();
        if (this.isConnected) this.scheduleStock();
      }
    }
    disconnectedCallback() {
      this.controller?.abort(); this.request?.abort();
      this.visibility?.disconnect(); this.scenes?.disconnect();
      clearTimeout(this.clockTimer); clearTimeout(this.stockTimer); cancelAnimationFrame(this.frame);
      this.controller = null; this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grindz-header"] && !Shopify.designMode) return;
  try {
    

(() => {
  const update=()=>{
    const destination=document.getElementById('GrindzDrop'),params=new URLSearchParams(location.search),preview=params.get('preview_theme_id');
    if(destination)document.querySelectorAll('[data-vault-link]').forEach(a=>{a.href='#GrindzDrop';});
    else if(location.protocol!=='file:'&&(preview||window.Shopify?.designMode)){
      const url=new URL(window.Shopify?.routes?.root||'/',location.origin);url.hash='GrindzDrop';if(preview)url.searchParams.set('preview_theme_id',preview);
      document.querySelectorAll('[data-vault-link]').forEach(a=>{a.href=url.href;});
    }
    if(location.protocol!=='file:'){
      const home=new URL(window.Shopify?.routes?.root||'/',location.origin);if(preview)home.searchParams.set('preview_theme_id',preview);
      document.querySelectorAll('[data-grindz-home]').forEach(a=>{a.href=home.href;});
      document.querySelectorAll('[data-grindz-manifesto]').forEach(a=>{a.href=document.querySelector('grindz-descent')?'#GrindzPrinciples-home':home.href+'#GrindzPrinciples-home';});
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update,{once:true});else update();
  document.addEventListener('shopify:section:load',update);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grindz-vault"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grindz-vault')) {
  customElements.define('grindz-vault', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.launch = this.querySelector('[data-launch]');
      this.drop = this.querySelector('[data-drop]');
      this.clock = this.querySelector('[data-countdown]');
      this.lastFetch = Date.now(); this.failures = 0;
      this.end = this.parseDate(this.dataset.date); this.formatDate();
      this.visibility = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === this.launch) this.clockVisible = entry.isIntersecting;
          if (entry.target === this.drop) this.dropVisible = entry.isIntersecting;
        }
        this.tick();this.scheduleStock();
      });
      this.visibility.observe(this.launch);this.visibility.observe(this.drop);
      this.bindRail();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-detail-toggle]');
        if (!button) return;
        const active = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed',String(active));button.closest('[data-product]').dataset.detail=String(active);
      }, {signal});
      document.addEventListener('visibilitychange', () => {if(document.hidden)this.request?.abort();this.tick();this.scheduleStock();}, {signal});
      window.addEventListener('online',()=>this.scheduleStock(),{signal});
      const params=new URLSearchParams(location.search);
      if(params.has('preview_theme_id')) {
        const url=new URL(window.Shopify?.routes?.root||'/',location.origin);url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
        this.querySelectorAll('[data-home-link]').forEach(link=>{link.href=url.href;});
      }
      this.tick();
    }
    parseDate(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [,year,month,day,hour,minute,second,zone] = match;
      const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);
      if (!Number.isFinite(+date) || date.toISOString().slice(0,19) !== value.slice(0,19)) return NaN;
      if (zone !== 'Z' && (+zone.slice(1,3) > 14 || +zone.slice(4) > 59 || (+zone.slice(1,3) === 14 && +zone.slice(4) !== 0))) return NaN;
      return Date.parse(value);
    }
    formatDate() {
      const display = this.querySelector('[data-date-display]');
      if (!Number.isFinite(this.end)) {display.textContent = this.querySelector('[data-no-date]').textContent; return;}
      const value = this.dataset.date;
      const local = new Date(value.slice(0,19) + 'Z');
      const text = new Intl.DateTimeFormat('es-CR', {dateStyle:'long', timeStyle:'short', timeZone:'UTC', hour12:false}).format(local);
      const time = document.createElement('time');
      time.dateTime = value;
      time.textContent = text + ' · UTC' + (value.endsWith('Z') ? '+00:00' : value.slice(-6));
      display.replaceChildren(time);
    }
    tick() {
      clearTimeout(this.clockTimer);
      const remaining = Number.isFinite(this.end) ? Math.max(0, Math.ceil((this.end - Date.now()) / 1000)) : 0;
      const previous = this.dataset.dropState;
      const state = this.dataset.closed === 'true' ? 'closed' : remaining > 0 ? 'scheduled' : this.dataset.hasProducts === 'true' ? 'active' : Number.isFinite(this.end) ? 'opening' : 'announced';
      this.dataset.dropState = state;
      const label=this.querySelector('[data-status="'+state+'"]')?.textContent||'';
      document.dispatchEvent(new CustomEvent('grindz:drop-state',{detail:{state,label:state==='scheduled'?label+' · '+this.querySelector('[data-date-display]').textContent:label}}));
      this.clock.hidden = state !== 'scheduled';
      if (previous === 'scheduled' && state !== previous) {
        this.querySelector('[data-announcement]').textContent = this.querySelector(`[data-status="${state}"]`).textContent;
        this.lastFetch = 0;
        this.scheduleStock();
      }
      if (state === 'scheduled') {
        const values = {days:Math.floor(remaining / 86400), hours:Math.floor(remaining / 3600) % 24, minutes:Math.floor(remaining / 60) % 60, seconds:remaining % 60};
        for (const [unit, value] of Object.entries(values)) {
          const node = this.querySelector(`[data-time="${unit}"]`);
          const text = String(value).padStart(2,'0');
          if (node.textContent !== text) node.textContent = text;
        }
        if (!document.hidden) this.clockTimer = setTimeout(() => this.tick(), this.clockVisible ? 1000 : Math.min(60000, remaining * 1000));
      }
    }
    bindRail() {
      this.rail = this.querySelector('[data-rail]');
      if (!this.rail) return;
      const signal = this.controller.signal;
      this.querySelector('[data-rail-controls]').hidden = false;
      this.querySelectorAll('[data-detail-toggle]').forEach(button => {button.hidden = false;});
      this.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
        this.rail.scrollBy({left:Number(button.dataset.railStep) * this.rail.clientWidth * .78, behavior:this.reduced.matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.rail.addEventListener('scroll', () => this.updateRail(), {passive:true, signal});
      this.updateRail();
    }
    updateRail() {
      if (!this.rail) return;
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      this.querySelector('[data-rail-step="-1"]').disabled = this.rail.scrollLeft <= 2;
      this.querySelector('[data-rail-step="1"]').disabled = this.rail.scrollLeft >= max - 2;
    }
    scheduleStock() {
      clearTimeout(this.stockTimer);
      if (!this.isConnected || this.dataset.refresh !== 'true' || !this.dropVisible || document.hidden || navigator.onLine === false || this.dataset.closed === 'true' || this.dataset.dropState === 'scheduled' || this.dataset.dropState === 'announced' || this.request) return;
      const interval = navigator.connection?.saveData ? 120000 : Math.min(240000, 45000 * 2 ** this.failures);
      this.stockTimer = setTimeout(() => this.refreshStock(), Math.max(0, interval - (Date.now() - this.lastFetch)));
    }
    async refreshStock() {
      if (this.request || document.hidden || !this.dropVisible) return;
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 8000);
      try {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', this.dataset.section);
        const response = await fetch(url, {signal:request.signal, credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Section unavailable');
        const sections = await response.json();
        const html = sections[this.dataset.section];
        if (typeof html !== 'string' || !html) throw new Error('Section missing');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById(this.id);
        if (!fresh) throw new Error('Section mismatch');
        let cards = [...this.querySelectorAll('[data-product]')];
        const freshCards = new Map([...fresh.querySelectorAll('[data-product]')].map(card => [card.dataset.product, card]));
        if (freshCards.size !== cards.length || cards.some(card => !freshCards.has(card.dataset.product))) {
          const target = this.querySelector('[data-lookbook]');
          const source = fresh.querySelector('[data-lookbook]');
          if (!target || !source) throw new Error('Lookbook missing');
          const hadFocus = target.contains(document.activeElement);
          const focusedProduct = document.activeElement.closest('[data-product]')?.dataset.product;
          const scroll = this.rail?.scrollLeft || 0;
          target.replaceChildren(...[...source.childNodes].map(node => document.importNode(node, true)));
          this.bindRail();
          if (this.rail) this.rail.scrollLeft = scroll;
          if (hadFocus) {
            const card = [...this.querySelectorAll('[data-product]')].find(item => item.dataset.product === focusedProduct);
            const focus = card?.querySelector('a') || this.querySelector('[data-launch] a');
            focus?.focus({preventScroll:true});
          }
          cards = [...this.querySelectorAll('[data-product]')];
        }
        for (const card of cards) {
          const updated = freshCards.get(card.dataset.product);
          const target = card.querySelector('[data-stock]');
          const source = updated.querySelector('[data-stock]');
          if (!target || !source) throw new Error('Stock missing');
          card.dataset.available = updated.dataset.available;
          const form=card.querySelector('.gz-buy'),freshForm=updated.querySelector('.gz-buy');
          if(!form&&freshForm)card.append(document.importNode(freshForm,true));
          else if(form&&form.dataset.busy!=='true'){
            if(!freshForm)form.hidden=true;
            else{
              form.hidden=false;const select=form.querySelector('select'),newSelect=freshForm.querySelector('select');
              if(select&&newSelect){const selection=select.value;select.replaceChildren(...[...newSelect.children].map(n=>document.importNode(n,true)));const option=[...select.options].find(o=>o.value===selection&&!o.disabled);select.value=option?selection:'';}
            }
          }
          if (target.innerHTML !== source.innerHTML) {
            const hadFocus = target.contains(document.activeElement);
            target.replaceChildren(...[...source.childNodes].map(node => document.importNode(node, true)));
            if (hadFocus) target.querySelector('a')?.focus({preventScroll:true});
          }
        }
        this.dataset.hasProducts = fresh.dataset.hasProducts;
        this.dataset.closed = fresh.dataset.closed;
        this.failures = 0;
        const note = this.querySelector('[data-stock-note]');
        if (note) note.textContent = note.dataset.fresh + ' ' + new Intl.DateTimeFormat('es-CR',{hour:'2-digit',minute:'2-digit',second:'2-digit'}).format(new Date());
        this.tick();
      } catch {
        this.failures = Math.min(3, this.failures + 1);
        const note = this.querySelector('[data-stock-note]');
        if (note && !document.hidden) note.textContent = note.dataset.stale;
      } finally {
        clearTimeout(timeout);
        this.request = null;
        this.lastFetch = Date.now();
        if (this.isConnected) this.scheduleStock();
      }
    }
    disconnectedCallback() {
      this.controller?.abort(); this.request?.abort();
      this.visibility?.disconnect(); this.scenes?.disconnect();
      clearTimeout(this.clockTimer); clearTimeout(this.stockTimer); cancelAnimationFrame(this.frame);
      this.controller = null; this.frame = 0;
    }
  });
}
if(!customElements.get('grindz-chamber'))customElements.define('grindz-chamber',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;this.controller=new AbortController();const signal=this.controller.signal;this.canvas=this.querySelector('canvas');this.cards=[...this.querySelectorAll('.gv-chamber')];this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.aim=0;this.turn=0;this.visible=false;this.paused=false;
    const allowed=()=>this.dataset.motion==='true'&&!this.motion.matches&&!navigator.connection?.saveData;
    this.observer=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;if(this.visible&&allowed()){if(!this.gl)this.init();this.queue();}else{cancelAnimationFrame(this.frame);this.frame=0;}},{rootMargin:'80px'});this.observer.observe(this);
    this.motion.addEventListener('change',()=>{if(!allowed()){cancelAnimationFrame(this.frame);this.frame=0;this.dataset.ready='false';}else if(this.visible){if(!this.gl)this.init();this.dataset.ready=String(!!this.gl);this.queue();}},{signal});
    this.addEventListener('pointermove',event=>{if(event.pointerType==='touch'||this.paused)return;const rect=this.getBoundingClientRect();this.aim=(event.clientX-rect.left-rect.width/2)/rect.width*.40;},{passive:true,signal});this.addEventListener('pointerleave',()=>{this.aim=0;},{signal});
    this.pause=this.querySelector('[data-chamber-pause]');this.pause.addEventListener('click',()=>{this.paused=!this.paused;this.pause.setAttribute('aria-pressed',String(this.paused));if(this.paused){cancelAnimationFrame(this.frame);this.frame=0;}else this.queue();},{signal});
    this.querySelector('.gv-files').addEventListener('scroll',()=>{if(this.gl&&this.paused)this.draw((this.lastTime||0)/1000);},{passive:true,signal});
    this.resize=new ResizeObserver(()=>{if(this.gl){this.size();this.draw((this.lastTime||0)/1000);}});this.resize.observe(this);
    document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(this.frame);this.frame=0;}else this.queue();},{signal});
    this.canvas.addEventListener('webglcontextlost',event=>{event.preventDefault();cancelAnimationFrame(this.frame);this.frame=0;this.gl=null;this.dataset.ready='false';this.pause.hidden=true;},{signal});this.canvas.addEventListener('webglcontextrestored',()=>{if(allowed()){this.init();this.queue();}},{signal});
  }
  init(){
    const gl=this.canvas.getContext('webgl',{alpha:true,antialias:true,powerPreference:'low-power'});if(!gl)return;this.gl=gl;
    try{
      const compile=(type,source)=>{const shader=gl.createShader(type);gl.shaderSource(shader,source);gl.compileShader(shader);return shader};
      const vs=compile(gl.VERTEX_SHADER,`precision highp float;attribute vec3 aPosition;attribute vec3 aNormal;uniform vec3 uAngles;uniform float uAspect;uniform float uFloat;varying vec3 vNormal;varying vec3 vPosition;void main(){vec3 c=cos(uAngles),s=sin(uAngles);mat3 rx=mat3(1.,0.,0.,0.,c.x,s.x,0.,-s.x,c.x);mat3 ry=mat3(c.y,0.,-s.y,0.,1.,0.,s.y,0.,c.y);mat3 rz=mat3(c.z,s.z,0.,-s.z,c.z,0.,0.,0.,1.);mat3 rotation=rz*ry*rx;vec3 p=rotation*aPosition+vec3(0.,uFloat,-4.);vNormal=rotation*aNormal;vPosition=p;gl_Position=vec4(p.x*2.9/uAspect,p.y*2.9,-1.002*p.z-.2,-p.z);}`);
      const fs=compile(gl.FRAGMENT_SHADER,`precision mediump float;varying vec3 vNormal;varying vec3 vPosition;void main(){vec3 n=normalize(vNormal),v=normalize(-vPosition);if(!gl_FrontFacing)n=-n;vec3 r=reflect(-v,n);float rim=pow(1.-abs(dot(n,v)),3.);float panel=pow(max(0.,dot(r,normalize(vec3(-.7,.55,.7)))),22.);float broad=pow(max(0.,dot(r,normalize(vec3(.5,.4,1.)))),5.);float grey=.025+panel*.46+broad*.14+rim*.22;gl_FragColor=vec4(vec3(grey),1.);}`);
      this.program=gl.createProgram();gl.attachShader(this.program,vs);gl.attachShader(this.program,fs);gl.linkProgram(this.program);gl.deleteShader(vs);gl.deleteShader(fs);if(!gl.getProgramParameter(this.program,gl.LINK_STATUS))throw Error();gl.useProgram(this.program);this.position=gl.getAttribLocation(this.program,'aPosition');this.normal=gl.getAttribLocation(this.program,'aNormal');this.uniforms=Object.fromEntries(['uAngles','uAspect','uFloat'].map(n=>[n,gl.getUniformLocation(this.program,n)]));
      this.models=[0,1,2].map(kind=>{const data=this.mesh(kind),buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(data),gl.STATIC_DRAW);return {buffer,count:data.length/6}});
      gl.enable(gl.DEPTH_TEST);gl.disable(gl.CULL_FACE);gl.clearColor(0,0,0,0);this.size();this.draw(0);this.dataset.ready='true';this.pause.hidden=false;
    }catch{this.release();this.dataset.ready='false';}
  }
  mesh(kind){
    const cols=14,rows=18,data=[];
    const profile=kind===0?[[0,.22],[.10,.28],[.22,.62],[.36,.68],[.46,.47],[1,.50]]:kind===1?[[0,.43],[.18,.61],[.85,.53],[1,.47]]:[[0,.39],[.14,.75],[.30,.76],[.43,.48],[1,.51]];
    const point=(u,v,back=false)=>{let i=0;while(i<profile.length-2&&v>profile[i+1][0])i++;const a=profile[i],b=profile[i+1];let t=Math.max(0,Math.min(1,(v-a[0])/(b[0]-a[0])));t=t*t*(3-2*t);const width=a[1]+(b[1]-a[1])*t;
      const y=(.5-v)*2.15,fold=Math.sin(u*10+v*2+kind)*.07+Math.cos(u*5-v*7)*.026;
      return [u*width,y,fold+(1-u*u)*.17-(back?.12:0)];};
    const cross=(a,b)=>{const n=[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]],l=Math.hypot(...n)||1;return n.map(x=>x/l)};
    const normal=(u,v,back)=>{const up=point(u+.001,v),um=point(u-.001,v),vp=point(u,v+.001),vm=point(u,v-.001);const n=cross(vp.map((x,i)=>x-vm[i]),up.map((x,i)=>x-um[i]));return back?n.map(x=>-x):n};
    const triangle=(a,b,c,normals)=>{const n=cross(b.map((x,i)=>x-a[i]),c.map((x,i)=>x-a[i]));[a,b,c].forEach((p,i)=>data.push(...p,...(normals?normals[i]:n)))};
    for(const back of [false,true])for(let y=0;y<rows;y++)for(let x=0;x<cols;x++){const u=x/cols*2-1,w=(x+1)/cols*2-1,v=y/rows,z=(y+1)/rows;const a=point(u,v,back),b=point(w,v,back),c=point(u,z,back),d=point(w,z,back),na=normal(u,v,back),nb=normal(w,v,back),nc=normal(u,z,back),nd=normal(w,z,back);if(back){triangle(a,b,c,[na,nb,nc]);triangle(b,d,c,[nb,nd,nc])}else{triangle(a,c,b,[na,nc,nb]);triangle(b,c,d,[nb,nc,nd])}}
    for(const u of [-1,1])for(let y=0;y<rows;y++){const a=point(u,y/rows),b=point(u,(y+1)/rows),c=point(u,y/rows,true),d=point(u,(y+1)/rows,true);triangle(a,b,c);triangle(b,d,c)}
    for(const v of [0,1])for(let x=0;x<cols;x++){const a=point(x/cols*2-1,v),b=point((x+1)/cols*2-1,v),c=point(x/cols*2-1,v,true),d=point((x+1)/cols*2-1,v,true);triangle(a,b,c);triangle(b,d,c)}
    return data;
  }
  size(){const rect=this.canvas.getBoundingClientRect();this.ratio=Math.min(devicePixelRatio||1,1.25,Math.sqrt(900000/Math.max(1,rect.width*rect.height)));const w=Math.max(1,Math.round(rect.width*this.ratio)),h=Math.max(1,Math.round(rect.height*this.ratio));if(this.canvas.width!==w||this.canvas.height!==h){this.canvas.width=w;this.canvas.height=h;}}
  queue(){if(!this.gl||this.frame||!this.visible||document.hidden||this.paused||this.motion.matches)return;this.frame=requestAnimationFrame(now=>{this.frame=0;if(now-(this.lastTime||0)>=32){this.lastTime=now;this.turn+=(this.aim-this.turn)*.12;this.draw(now/1000);}this.queue();});}
  draw(time){
    const gl=this.gl;if(!gl)return;gl.useProgram(this.program);gl.disable(gl.SCISSOR_TEST);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.enable(gl.SCISSOR_TEST);const area=this.canvas.getBoundingClientRect();
    this.cards.forEach((card,index)=>{const rect=card.getBoundingClientRect();if(rect.right<=area.left||rect.left>=area.right)return;const x=Math.round((rect.left-area.left)*this.ratio),y=Math.round((area.bottom-rect.bottom)*this.ratio),w=Math.round(rect.width*this.ratio),h=Math.round(rect.height*this.ratio);gl.viewport(x,y,w,h);gl.scissor(Math.max(0,x),Math.max(0,y),Math.min(w,this.canvas.width-Math.max(0,x)),Math.min(h,this.canvas.height-Math.max(0,y)));const model=this.models[index];gl.bindBuffer(gl.ARRAY_BUFFER,model.buffer);gl.enableVertexAttribArray(this.position);gl.vertexAttribPointer(this.position,3,gl.FLOAT,false,24,0);gl.enableVertexAttribArray(this.normal);gl.vertexAttribPointer(this.normal,3,gl.FLOAT,false,24,12);gl.uniform3f(this.uniforms.uAngles,.07+Math.sin(time*.3+index)*.04,Math.sin(time*.34+index)*.22+this.turn+(index-1)*.18,Math.sin(time*.28+index)*.045);gl.uniform1f(this.uniforms.uAspect,w/h);gl.uniform1f(this.uniforms.uFloat,Math.sin(time*.7+index*2)*.065);gl.drawArrays(gl.TRIANGLES,0,model.count);});gl.disable(gl.SCISSOR_TEST);
  }
  release(){if(this.gl){this.models?.forEach(m=>this.gl.deleteBuffer(m.buffer));if(this.program)this.gl.deleteProgram(this.program);}this.gl=null;}
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();this.observer?.disconnect();this.resize?.disconnect();this.release();this.controller=null;this.frame=0;}
});

(() => {
  if(window.grindzPurchaseBound)return;window.grindzPurchaseBound=true;
  document.addEventListener('submit',async event=>{
    const form=event.target;if(!form.matches('grindz-vault form.gz-buy')||!window.fetch)return;
    event.preventDefault();if(form.dataset.busy==='true'||!form.reportValidity())return;
    const vault=form.closest('grindz-vault'),button=form.querySelector('[name="add"]'),status=form.querySelector('[data-buy-status]'),next=form.querySelector('[data-cart-next]');
    if(vault.dataset.dropState!=='active')return;
    const payload=new FormData(form);form.dataset.busy='true';form.setAttribute('aria-busy','true');button.disabled=true;button.textContent=button.dataset.busyLabel;status.textContent='';next.hidden=true;
    const request=new AbortController(),timeout=setTimeout(()=>request.abort(),12000);
    try{
      const endpoint=vault.dataset.addUrl.replace(/\/$/,'')+'.js';
      const response=await fetch(endpoint,{method:'POST',body:payload,credentials:'same-origin',headers:{Accept:'application/json'},signal:request.signal});
      const data=await response.json();
      if(!response.ok){status.textContent=typeof data.description==='string'?data.description:status.dataset.error;return;}
      status.textContent=status.dataset.success;next.hidden=false;
      document.dispatchEvent(new CustomEvent('grindz:cart-added',{detail:{variantId:payload.get('id')}}));
      try{
        const cartResponse=await fetch(vault.dataset.cartUrl.replace(/\/$/,'')+'.js',{credentials:'same-origin',headers:{Accept:'application/json'},signal:request.signal});
        if(cartResponse.ok){const cart=await cartResponse.json();if(Number.isInteger(cart.item_count))document.querySelectorAll('[data-grindz-cart-count]').forEach(el=>{el.textContent='['+cart.item_count+']';});}
      }catch{}
    }catch{status.textContent=status.dataset.error;next.hidden=false;}
    finally{clearTimeout(timeout);form.dataset.busy='false';form.removeAttribute('aria-busy');button.disabled=false;button.textContent=button.dataset.addLabel+' +';}
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
